import React from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { BLOCKS, INLINES } from "@contentful/rich-text-types"
import Typography from "@material-ui/core/Typography"
import Link from "@material-ui/core/Link"

const RichText = ({ richTextJson }) => {
  const options = {
    renderNode: {
      [INLINES.HYPERLINK]: (node, children) => (
        <Link href={node.data.uri} color="primary">
          {children}
        </Link>
      ),
      [BLOCKS.HEADING_1]: (node, children) => (
        <Typography
          variant="h1"
          id={`${children[0].toLowerCase().split(" ").join("-")}-section`}
        >
          {children}
        </Typography>
      ),
      [BLOCKS.HEADING_2]: (node, children) => (
        <Typography
          variant="h2"
          id={`${children[0].toLowerCase().split(" ").join("-")}-section`}
        >
          {children}
        </Typography>
      ),
      [BLOCKS.HEADING_3]: (node, children) => (
        <Typography
          variant="h3"
          id={`${children[0].toLowerCase().split(" ").join("-")}-section`}
        >
          {children}
        </Typography>
      ),
      [BLOCKS.HEADING_4]: (node, children) => (
        <Typography variant="h4">{children}</Typography>
      ),
      [BLOCKS.HEADING_5]: (node, children) => (
        <Typography variant="h5">{children}</Typography>
      ),
      [BLOCKS.HEADING_6]: (node, children) => (
        <Typography variant="h6">{children}</Typography>
      ),
      [BLOCKS.PARAGRAPH]: (node, children) => (
        <Typography variant="body1">{children}</Typography>
      ),
      [BLOCKS.LIST_ITEM]: (node, children) => {
        const UnTaggedChildren = documentToReactComponents(node, {
          renderNode: {
            [BLOCKS.PARAGRAPH]: (childNode, children) => children,
            [BLOCKS.LIST_ITEM]: (childNode, children) =>
              childNode === node ? (
                children
              ) : (
                <li key={children}>{children}</li>
              ),
          },
        })

        return <li>{UnTaggedChildren}</li>
      },
    },
  }

  return documentToReactComponents(JSON.parse(richTextJson), options)
}
export default RichText
